import { render, staticRenderFns } from "./supplier-product-row.vue?vue&type=template&id=120cd6d4&scoped=true&"
import script from "./supplier-product-row.vue?vue&type=script&lang=js&"
export * from "./supplier-product-row.vue?vue&type=script&lang=js&"
import style0 from "./supplier-product-row.vue?vue&type=style&index=0&id=120cd6d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120cd6d4",
  null
  
)

export default component.exports